import Home from "../Pages/Home";
import Dashboard from "../Pages/Dashboard";
import Login from "../Pages/Auth/Login";
import VerifyCode from "../Pages/Auth/VerfiyCode";
import BlogList from "../Pages/Blogs/List";
import BlogSingle from "../Pages/Blogs/Single";
import Layout from "../Layouts/MainLayout";
import AuthLayout from "../Layouts/Auth";
import PanelLayout from "../Layouts/Panel";
import NotFound from "../Pages/NotFound";
import ContactUs from "../Pages/Contact";
import AboutUs from "../Pages/About";
import Single from "../Pages/Single";
import ListProduct from "../Pages/List";
import Profile from "../Pages/Profile";
import Support from "../Pages/Support";
import CreateAds from "../Pages/Ads/Create";
import Signup from "../Pages/Auth/Signup";
import Plans from "../Pages/Plans";
import AdsList from "../Pages/Ads/List";
import SingleAds from "../Pages/Ads/Single";
import BookMarKList from "../Pages/BookMark/List";
import Peyments from "../Pages/Payments/List";
import SinglePeyments from "../Pages/Payments/Single";
import PaymentResult from "../Pages/Payments/payResult";
import Terms from "../Pages/terms";


export const routes = [
  {
    path: "*",
    component: NotFound,
    layout: Layout,
  },
  {
    path: "/",
    component: Home,
    layout: Layout,
  },
  {
    path: "/blogs",
    layout: Layout,
    component: BlogList,
  },
  {
    layout: Layout,
    path: "/blogs/:slug",
    component: BlogSingle,
  },
  {
    layout: Layout,
    path: "/contact-us",
    component: ContactUs,
  },
  {
    layout: Layout,
    path: "/about-us",
    component: AboutUs,
  },
  {
    layout: Layout,
    path: "/terms",
    component: Terms,
  },
  {
    layout: Layout,
    path: "/ads/:citySlug",
    component: ListProduct,
  },
  {
    layout: Layout,
    path: "/ads/:citySlug/:slug",
    component: Single,
  },
  {
    layout: PanelLayout,
    path: "/dashboard",
    component: Dashboard,
  },
  {
    layout: AuthLayout,
    path: "/login",
    component: Login,
  },
  {
    layout: AuthLayout,
    path: "/verifycode",
    component: VerifyCode,
  },
  {
    layout: PanelLayout,
    path: "/profile",
    component: Profile,
  },
  {
    layout: PanelLayout,
    path: "/support",
    component: Support,
  },
  {
    layout: PanelLayout,
    path: "/ads-submit",
    component: CreateAds,
  },
  {
    layout: AuthLayout,
    path: "/signup",
    component: Signup,
  },
  {
    layout: PanelLayout,
    path: "/plans",
    component: Plans,
  },
  {
    layout: PanelLayout,
    path: "/my-ads",
    component: AdsList,
  },
  {
    layout: PanelLayout,
    path: "/my-ads/:id",
    component: SingleAds,
  },
  {
    layout: PanelLayout,
    path: "/pay/result",
    component: PaymentResult,
  },
  {
    layout: PanelLayout,
    path: "/my-payments",
    component: Peyments,
  },
  {
    layout: PanelLayout,
    path: "/my-payments/:id",
    component: SinglePeyments,
  },
  {
    layout: PanelLayout,
    path: "/book-marks",
    component: BookMarKList,
  },
];
